export const HintReportsRoute = {
  HINT_REPORTS: 'smartslides',
  HINT_REPORTS_SLIDE: 'smartslides/slide',
  HINT_REPORTS_SLIDE_NEW: 'smartslides/slide/new',
  HINT_REPORTS_SLIDES: 'smartslides/slides',
  HINT_REPORTS_TEMPLATE: 'smartslides/template',
  HINT_REPORTS_TEMPLATES: 'smartslides/templates',
};

export const HintReportsPathName = {
  HINT_REPORTS: 'smartslides',
  HINT_REPORTS_FORM_NEW: 'hintreportsform:new',
  HINT_REPORTS_FORM: 'hintreportsform',
  HINT_REPORTS_GENERATE: 'hintreportsgenerate',
  HINT_REPORTS_PREVIEW: 'hintreportspreview',
  HINT_REPORTS_TEMPLATE_FORM: 'hintreportstemplateform',
  HINT_REPORTS_TEMPLATE_FORM_NEW: 'hintreportstemplateform:new',
};

export const HintReportsPath = {
  DOWNLOAD: 'download',
  GENERATE: 'generate',
  PREVIEW: 'preview',
  TEMPLATES: 'templates',
  THEMES: 'themes',
  VALIDATE: 'validate',
};

export const HintReportsStatus = {
  inProgress: 'in_progress',
  error: 'error',
  success: 'success',
};

export const HintReportsThemeType = {
  client: 'client',
  instance: 'instance',
  default: 'default',
};

export const HintReportsThemePrefixes = {
  client: '@client_',
  instance: '.com@theme_',
  default: 'default@theme_',
  theme: '@theme_',
};

export const SelectOptions = {
  FIELD: 'field',
  LABEL: 'label',
  ID: 'id',
  NAME: 'name',
  TITLE: 'title',
};

export const SelectRefs = {
  dataviewSelect: 'data-view-select-',
  metricsSelect: 'metrics-select-',
  groupbysSelect: 'groupbys-select-',
  widgetSelect: 'widget-select-',
};

export const HintReportsDefaultOptions = {
  reportType: 'performance_report',
  audience: 'executive_team',
  focus_areas: ['kpis_only', 'campaign_highlights', 'insights_recommendations'],
};

export const DataSourcePrefix = {
  service: 'service_',
};

export const Icons = {
  loading: 'loading',
  download: 'download',
};

export const DataFetchParams = {
  label: 'label',
};

export const HintReportsTabs = {
  SLIDES: 'slides',
  TEMPLATES: 'templates',
};

export const HintReportsTabEntityName = {
  [HintReportsTabs.SLIDES]: i18n.$t('SmartSlides'),
  [HintReportsTabs.TEMPLATES]: i18n.$t('Template'),
};

export const NEW_STRING = 'new';

export const CalendarDirection = {
  RIGHT: 'right',
};

export const HintReportTypes = {
  DATA_CATEGORY: 'dataCategory',
  DASHBOARD: 'dashboard',
};

export const HintReportsTypesOptions = [
  {
    key: HintReportTypes.DATA_CATEGORY,
    value: i18n.$t('Data Category'),
  },
  {
    key: HintReportTypes.DASHBOARD,
    value: i18n.$t('Dashboard'),
  },
];

export const HintReportNotificationType = {
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
  SUCCESS: 'success',
};

export const TextConstants = {
  TEMPLATE_CHANGE_HEADING: i18n.$t('Your selected template has been updated.'),
  SECTIONS_WIDGETS_CHANGED_MESSAGE: i18n.$t(
    'Some sections or widgets in the linked dashboard were changed since you last used this template. A few items may have been deleted or moved.'
  ),
};

export const HintReportEvent = {
  DATA_CATEGORY_CLIENT_SELECTED: 'HintReportEvent:data_category_client_selected',
  DATA_CATEGORY_TEMPLATE_SELECTED: 'HintReportEvent:data_category_template_selected',
  DATA_CATEGORY_INIT_FORM: 'HintReportEvent:data_category_init_form',
  DATA_CATEGORY_RESET_FORM: 'HintReportEvent:data_category_reset_form',
  DATA_CATEGORY_FORM_SAVE_SUCCESS: 'HintReportEvent:data_category_form_save_success',
  DASHBOARD_CLIENT_SELECTED: 'HintReportEvent:dashboard_client_selected',
  DASHBOARD_TEMPLATE_SELECTED: 'HintReportEvent:dashboard_template_selected',
  DASHBOARD_INIT_FORM: 'HintReportEvent:dashboard_init_form',
  DASHBOARD_RESET_FORM: 'HintReportEvent:dashboard_reset_form',
  DASHBOARD_FORM_SAVE_SUCCESS: 'HintReportEvent:dashboard_form_save_success',
  DASHBOARD_UPDATE_WIDGET_IDS: 'HintReportEvent:dashboard_widget_ids',
};
